<script>
import ZuoraAvailabilityAlert from '~/javascripts/components/zuora_availability_alert.vue';

export default {
  name: 'ZuoraAvailabilityWrapper',
  components: {
    ZuoraAvailabilityAlert,
  },
  computed: {
    zuoraOfflineModeEnabled() {
      return gon.features?.zuoraOfflineModeEnabled;
    },
  },
};
</script>

<template>
  <div>
    <zuora-availability-alert v-if="zuoraOfflineModeEnabled" />

    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>
